import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconLinkedinDark = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.78357 4.47846C5.78326 5.15705 5.37157 5.7677 4.74262 6.02246C4.11367 6.27722 3.39306 6.12522 2.92059 5.63814C2.44811 5.15105 2.31813 4.42614 2.59192 3.80524C2.86572 3.18434 3.48862 2.79143 4.1669 2.81179C5.0678 2.83883 5.78398 3.57716 5.78357 4.47846ZM5.83357 7.37846H2.50024V17.8118H5.83357V7.37846ZM11.1003 7.37846H7.78357V17.8118H11.0669V12.3368C11.0669 9.28677 15.0419 9.00343 15.0419 12.3368V17.8118H18.3336V11.2034C18.3336 6.06179 12.4503 6.25346 11.0669 8.77843L11.1003 7.37846Z",
		fill: "#03314B"
	})
});
export default SvgIconLinkedinDark;
